import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { pick } from 'lodash';

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work should consider refgactoring/removing this component.
 */
class GridRowContainer extends Component {
  constructor(props) {
    super(props);

    this.verifyProps = this.verifyProps.bind(this);

    this.state = {
      data: {},
    };
  }

  verifyProps() {
    if (this.props.columnSettings === null) {
      console.error(
        "gridRowContainer: The columnSettings prop is null and it shouldn't be"
      );
    }
  }

  render() {
    this.verifyProps();

    if (typeof this.props.data === 'undefined') {
      return <tbody />;
    }
    const arr = [];

    const columns = this.props.columnSettings.getColumns();

    arr.push(
      <this.props.rowSettings.rowComponent
        useGriddleStyles={this.props.useGriddleStyles}
        isSubGriddle={this.props.isSubGriddle}
        data={
          this.props.rowSettings.isCustom
            ? pick(this.props.data, columns)
            : this.props.data
        }
        rowData={this.props.rowSettings.isCustom ? this.props.data : null}
        columnSettings={this.props.columnSettings}
        rowSettings={this.props.rowSettings}
        hasChildren={this.props.hasChildren}
        toggleChildren={this.toggleChildren}
        key={`${this.props.uniqueId}${'_base_row'}`}
        useGriddleIcons={this.props.useGriddleIcons}
        parentRowExpandedClassName={this.props.parentRowExpandedClassName}
        parentRowCollapsedClassName={this.props.parentRowCollapsedClassName}
        parentRowExpandedComponent={this.props.parentRowExpandedComponent}
        parentRowCollapsedComponent={this.props.parentRowCollapsedComponent}
        paddingHeight={this.props.paddingHeight}
        rowHeight={this.props.rowHeight}
        onRowClick={this.props.onRowClick}
        multipleSelectionSettings={this.props.multipleSelectionSettings}
        rowIndex={this.props.rowIndex}
        content={this.props.content}
        customClick={this.props.customClick}
        rowClickIndex={this.props.rowClickIndex}
        rowCustomClass={this.props.rowCustomClass}
        showChildren={this.props.showChildren}
      />
    );

    let children = null;

    if (this.props.showChildren) {
      children =
        this.props.hasChildren &&
        this.props.data['children'].map((row, index) => {
          const key = this.props.rowSettings.getRowKey(row, index);

          if (typeof row['children'] !== 'undefined') {
            const Griddle = this.constructor.Griddle;
            return (
              <tr key={key} style={{ paddingLeft: 5 }}>
                <td
                  colSpan={this.props.columnSettings.getVisibleColumnCount()}
                  className="griddle-parent"
                  style={
                    this.props.useGriddleStyles
                      ? { border: 'none', padding: '0 0 0 5px' }
                      : null
                  }
                >
                  <Griddle
                    rowMetadata={{ key: 'id' }}
                    isSubGriddle
                    results={[row]}
                    columns={this.props.columnSettings.getColumns()}
                    tableClassName={this.props.tableClassName}
                    parentRowExpandedClassName={
                      this.props.parentRowExpandedClassName
                    }
                    parentRowCollapsedClassName={
                      this.props.parentRowCollapsedClassName
                    }
                    showTableHeading={false}
                    showPager={false}
                    columnMetadata={this.props.columnSettings.columnMetadata}
                    parentRowExpandedComponent={
                      this.props.parentRowExpandedComponent
                    }
                    parentRowCollapsedComponent={
                      this.props.parentRowCollapsedComponent
                    }
                    paddingHeight={this.props.paddingHeight}
                    rowHeight={this.props.rowHeight}
                    content={this.props.content}
                  />
                </td>
              </tr>
            );
          }

          const RowComponent = this.props.rowSettings.rowComponent;

          return (
            <RowComponent
              useGriddleStyles={this.props.useGriddleStyles}
              isSubGriddle={this.props.isSubGriddle}
              data={row}
              columnSettings={this.props.columnSettings}
              isChildRow
              columnMetadata={this.props.columnSettings.columnMetadata}
              key={key}
              content={this.props.content}
              customClick={this.props.customClick}
            />
          );
        });
    }

    if (this.props.useCustomChildRow?.(this.props.data)) {
      return (
        <tbody className={this.props.customChildRowContainerClass}>
          {arr[0]}
          <tr className="child-row">
            {this.props.multipleSelectionSettings?.isMultipleSelection && (
              <td>&nbsp;</td>
            )}
            <td colSpan={this.props.columnSettings.getVisibleColumnCount()}>
              {this.props.customChildRow}
            </td>
          </tr>
        </tbody>
      );
    }

    const childrenRows = this.props.showChildren ? arr.concat(children) : arr;
    return (
      <tbody>{this.props.hasChildren === false ? arr[0] : childrenRows}</tbody>
    );
  }
}

GridRowContainer.defaultProps = {
  useGriddleStyles: true,
  useGriddleIcons: true,
  isSubGriddle: false,
  columnSettings: null,
  rowSettings: null,
  paddingHeight: null,
  rowHeight: null,
  parentRowCollapsedClassName: 'parent-row',
  parentRowExpandedClassName: 'parent-row expanded',
  parentRowCollapsedComponent: '▶',
  parentRowExpandedComponent: '▼',
  onRowClick: null,
  multipleSelectionSettings: null,
  rowClickIndex: -1,
  customChildRow: null,
  customChildRowContainerClass: null,
  useCustomChildRow: null,
};

GridRowContainer.propTypes = {
  content: PropTypes.object,
  rowSettings: PropTypes.object,
  customClick: PropTypes.func,
  columnSettings: PropTypes.object,
  data: PropTypes.object.isRequired,
  useGriddleStyles: PropTypes.bool,
  isSubGriddle: PropTypes.bool,
  parentRowExpandedClassName: PropTypes.string,
  parentRowCollapsedClassName: PropTypes.string,
  parentRowExpandedComponent: PropTypes.string,
  parentRowCollapsedComponent: PropTypes.string,
  multipleSelectionSettings: PropTypes.object,
  rowIndex: PropTypes.number,
  customChildRow: PropTypes.object,
  customChildRowContainerClass: PropTypes.string,
  useCustomChildRow: PropTypes.func,
};

export { GridRowContainer };
